import { stegaClean } from "@sanity/client/stega";
import { GROQCTA, GROQPageCTASchema } from "@/sanity/lib/definitions";

// The Top Banner is a singleton document, opened from the Studio sidebar
export const TOP_BANNER_ID = "topBanner";

export interface ITopBanner {
  isEnabled?: boolean;
  startDate?: string;
  endDate?: string;
  text?: string;
  mobileText?: string;
  cta?: GROQCTA;
}

export const TopBannerQuery = `*[_id == "${TOP_BANNER_ID}"][0]{
  isEnabled,
  startDate,
  endDate,
  text,
  mobileText,
  cta->${GROQPageCTASchema}
}`;

export type TopBannerStatus = "disabled" | "scheduled" | "live" | "ended";

type TopBannerSchedule = Pick<ITopBanner, "isEnabled" | "startDate" | "endDate">;

function parseDate(value?: string) {
  return value ? Date.parse(stegaClean(value)) : NaN;
}

export function getTopBannerStatus(banner: TopBannerSchedule | null | undefined, now = Date.now()): TopBannerStatus {
  if (!banner?.isEnabled) return "disabled";

  const start = parseDate(banner.startDate);
  const end = parseDate(banner.endDate);
  if (Number.isNaN(start) || Number.isNaN(end)) return "disabled";

  if (now < start) return "scheduled";
  if (now >= end) return "ended";
  return "live";
}

// Milliseconds until the banner next starts or ends, or null when nothing is left to change
export function msUntilTopBannerChange(banner: TopBannerSchedule | null | undefined, now = Date.now()) {
  const status = getTopBannerStatus(banner, now);
  if (status === "scheduled") return parseDate(banner?.startDate) - now;
  if (status === "live") return parseDate(banner?.endDate) - now;
  return null;
}
